import { NAME } from '../constants';

export const UPDATE_DATA = `${NAME}/update`;
export const REMOVE_DATA = `${NAME}/remove`;
export const REQUEST_DATA = `${NAME}/request`;
export const RECEIVE_DATA = `${NAME}/receive`;
export const INITIALIZE_PROJECTS = `${NAME}/initializeProjects`;
export const DELETE_STATUS_MSG = `${NAME}/deleteStatusMsg`;
export const RECEIVE_ERROR = `${NAME}/receiveError`;
export const REPLACE_INSTANCE_SETTINGS = `${NAME}/replaceInstanceSettings`;
